module.exports = __webpack_public_path__ + "static/media/id.33435665.svg";